import { Component } from '@angular/core';

/**
 * LayoutComponent simplificado.
 * Actúa como contenedor para el router-outlet.
 * El header y menú de usuario ahora están en ChatbotComponent.
 */
@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css'],
})
export class LayoutComponent {}
